import { WarningTriangle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconWarningTriangle12Line = createIcon(
  WarningTriangle,
  12,
  "Line"
);
export const IconWarningTriangle16Line = createIcon(
  WarningTriangle,
  16,
  "Line"
);
export const IconWarningTriangle20Line = createIcon(
  WarningTriangle,
  20,
  "Line"
);
export const IconWarningTriangle24Line = createIcon(
  WarningTriangle,
  24,
  "Line"
);
export const IconWarningTriangle32Line = createIcon(
  WarningTriangle,
  32,
  "Line"
);
export const IconWarningTriangle48Line = createIcon(
  WarningTriangle,
  48,
  "Line"
);
export const IconWarningTriangle64Line = createIcon(
  WarningTriangle,
  64,
  "Line"
);
